
































































































































































































































import Expand from '@/components/Expand.vue';
import Detalle from '@/components/Detalle.vue';
import Contrato from '@/models/Contrato';
import Cosecha from '@/models/Cosecha';
import Grano from '@/models/Grano';
import Resumen from '@/models/Resumen';
import Entidad from '@/models/Entidad';
export default {
	name: 'Contratos',
	inject: ['responsive'],
	props: {
		directo: Boolean,
	},
	components: {
		Expand,
		Detalle,
	},
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			radio: 1,
			codcomexpand: '',
			codtalexpand: '',
			numeroexpand: '',
			scrollPosition: 0,
			recordSelected: {},
			showBtnMore: false,
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			imprime: false,
			tableGranos: true,
			loading: true,
			loadingExpand: false,
			expandido: false,
			grano: 0,
			granoselected: 0,
			active_tab: '',
			start: 0,
			limit: 7,
			resumen: '',
			codcom: '',
			searchForm: {
				fechaDesde: '',
				fechaHasta: '',
				cosechaselect: [],
				rangofecha: '',
			},
			searchRules: {
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
			},
		};
	},
	watch: {
		granoselected() {
			this.resetData();
			this.callResumen();
		},
	},
	computed: {
		resumenes(): Resumen {
			return this.$store.state.contratos.resumenes;
		},
		tableData(): Contrato {
			return this.$store.state.contratos.items;
		},
		totales(): Object {
			return this.$store.state.contratos.totales;
		},
		granos(): Grano {
			return this.$store.state.contratos.granos;
		},
		cosechas(): Cosecha {
			return this.$store.state.contratos.cosechas;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
	},
	filters: {
		capitalize: function (value: string): String {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value: number): String {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		disabledDateD(date: Date): Boolean {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date: Date): Boolean {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		tableRowClassName({ row, rowIndex }): String {
			let bg,
				clase: string = '';
			if (rowIndex === 0) {
				bg = 'bgGray';
				this.gray = true;
			}
			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha !== row.fecha) bg = this.gray ? 'bgGray' : '';

			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha === row.fecha) clase = this.gray ? 'bgGray' : '';
			else if (this.tableData[rowIndex + 1] && this.tableData[rowIndex + 1].fecha === row.fecha) clase = `sacarBorde ${bg}`;
			else clase = `bordeArriba ${bg}`;

			return clase;
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		load(row): void {
			row.expandido = true;
			this.codcomexpand = row.codcom;
			this.codtalexpand = row.codtal;
			this.numeroexpand = row.numero;
		},
		getSummaries(param): object {
			const { columns, data } = param;
			const sums: string[] = [];
			columns.forEach((column, index) => {
				if (index === 3) {
					sums[index] = 'Totales';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) sums[index] = this.totales[column.property];
				else sums[index] = '';
			});

			return sums;
		},
		range(array, min, max) {
			return array.slice(min, max);
		},
		changeGrano(tab): void {
			this.$router.push(`/contratos/${this.granos[parseInt(tab.index)].grano}`);
			this.granoselected = this.granos[parseInt(tab.index)].grano;
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: Contrato): void {
			this.detailsDrawer = !this.detailsDrawer;
			this.recordSelected = record;
			this.tableGranos = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		doSearch(): void {
			//TODO: refactor
			const me = this;
			const gra = this.granos.filter(function (gr: Grano) {
				return gr.descripcion == me.active_tab;
			});
			const desde = !this.responsive.isMobile
				? this.searchForm.rangofecha[0]
					? this.convertDate(this.searchForm.rangofecha[0])
					: ' '
				: this.searchForm.fechaDesde
				? this.convertDate(this.searchForm.fechaDesde)
				: ' ';
			this.searchForm.fechaDesde = desde;
			const hasta = !this.responsive.isMobile
				? this.searchForm.rangofecha[1]
					? this.convertDate(this.searchForm.rangofecha[1])
					: ' '
				: this.searchForm.fechaHasta
				? this.convertDate(this.searchForm.fechaHasta)
				: ' ';
			this.searchForm.fechaHasta = hasta;
			this.searchDrawer = false;
			this.$router.push(`/contratos/${gra[0].grano}`);
			this.resetData();
			this.callResumen();
		},
		convertDate(inputFormat: string): string {
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		doImprimir(type: string): void {
			let params = {
				url: './api/public/proxy/cgi/etenet_contratos',
				type: type,
				data: this.loadConfig(),
			};
			window.open(
				`${params.url}?fechaDesde=${params.data.params.fechaDesde}&fechaHasta=${params.data.params.fechaHasta}&codcom=${
					params.data.params.comprobantes
				}&codres=${params.data.params.codres}&grano=${params.data.params.grano}&cosecha=${
					params.data.params.cosecha
				}&token=${localStorage.getItem('accessToken')}&files=true&type=${params.type}&cooperativa=${
					this.$store.state.config.cuit
				}&entity_id=${this.$store.state.perfil.codent}`
			);
		},
		//metodo no utilizado, boton oculto
		downloadFiles(): void {
			let config = this.loadConfig();
			config.params.zip = true;
			config.params.imprime = true;
			let params = {
				url: './api/public/proxy/cgi/etenet_contratos',
				data: config,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(num: number): void {
			let params = {
				num: num,
				recordSelected: this.recordSelected,
			};
			this.imprimiendo = true;
			this.$store.dispatch('downloadFileContratos', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar el archivo',
						position: 'top-right',
					});
				} else {
					const x = window.open();
					if (!x) throw new Error();
					x.document.open();
					x.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${response.archivos.archivo}"></iframe>`);
					x.document.close();
				}
				this.imprimiendo = false;
			});
		},
		resetData(): void {
			this.$store.dispatch('resetItems');
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			let params = {
				start: this.start,
				limit: this.limit,
				data: this.loadConfig(),
			};
			this.$store.dispatch('callResumenContratos', params).then((response: Contrato[]) => {
				if (response) {
					response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
					this.loading = false;
					this.refresh = false;
					const gr = this.$route.params.grano ? this.$route.params.grano : this.granos[0].grano;
					this.active_tab = this.granos.filter((grano: Grano) => {
						return grano.grano === gr;
					})[0].descripcion;
					const conta = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else this.loading = false;
			});
		},
		loadConfig(): object {
			let config = {
				params: {
					fechadesde: this.searchForm.fechaDesde,
					fechahasta: this.searchForm.fechaHasta,
					codres: this.resumen,
					grano: this.granoselected,
					cosecha: `[${this.searchForm.cosechaselect}]`,
				},
			};
			return config;
		},
		numberFormatter(row: Contrato): string {
			return `${row.codcom2}  ${row.codtal2}  ${row.numero2}`;
		},
		changeResumen(resumen: Resumen): void {
			this.resumen = resumen;
			this.loading = true;
			this.resetData();
			this.callResumen();
		},
	},
	mounted() {
		//TODO: para agegar la cosecha al router
		//this.searchForm.cosechaselect = this.$route.params.cosecha ? this.$route.params.cosecha : '';
		this.granoselected = this.$route.params.grano ? this.$route.params.grano : 1;
		//this.$router.push(`/contratos/${this.granoselected}/${this.searchForm.cosechaselect}`);
		this.$router.push(`/contratos/${this.granoselected}`);
		if (!this.responsive.mobile) window.addEventListener('scroll', this.updateScroll);
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
